import React, { useState } from 'react';
import { ModalBase } from './ModalBase';

const SUBJECT_OPTIONS = ['Dúvida sobre plano', 'Problema no app', 'Parceria', 'Outro'];

interface ContatoForm {
  name: string;
  email: string;
  subject: string;
  message: string;
}

export function ContatoModal() {
  const [form, setForm] = useState<ContatoForm>({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (field: keyof ContatoForm) => (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
  ) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSubmit = () => {
    setSubmitted(true);
  };

  return (
    <ModalBase>
      <h3 className="modal-box__title">Fale com a gente</h3>
      <p className="modal-box__subtitle">Respondemos em até 1 dia útil</p>

      <label className="modal-form__label">
        Nome <span className="modal-form__label-required">*</span>
      </label>
      <input
        type="text"
        placeholder="Seu nome"
        value={form.name}
        onChange={handleChange('name')}
        className="modal-form__input"
      />

      <label className="modal-form__label">
        E-mail <span className="modal-form__label-required">*</span>
      </label>
      <input
        type="email"
        placeholder="seu@email.com"
        value={form.email}
        onChange={handleChange('email')}
        className="modal-form__input"
      />

      <label className="modal-form__label">
        Assunto <span className="modal-form__label-required">*</span>
      </label>
      <select
        value={form.subject}
        onChange={handleChange('subject')}
        className="modal-form__select"
      >
        <option value="">Selecione</option>
        {SUBJECT_OPTIONS.map((opt) => (
          <option key={opt} value={opt}>{opt}</option>
        ))}
      </select>

      <label className="modal-form__label">
        Mensagem <span className="modal-form__label-required">*</span>
      </label>
      <textarea
        placeholder="Como podemos ajudar?"
        rows={4}
        value={form.message}
        onChange={handleChange('message')}
        className="modal-form__textarea"
      />

      <button className="modal-form__submit" onClick={handleSubmit}>
        Enviar mensagem
      </button>

      {submitted && (
        <div className="modal-form__success">Mensagem enviada! Retornaremos em breve.</div>
      )}
    </ModalBase>
  );
}
